import { Link, useRouteError } from "react-router-dom";

import { Panel } from "./Panel";

/**
 * Ошибка внутри маршрута.
 *
 * В отличие от ErrorBoundary, который ловит всё дерево, этот рубеж заменяет
 * только содержимое страницы: шапка, индикатор связи и сокет с подписками
 * остаются живы, и оператору достаточно уйти на другой рынок.
 */
export function RouteError() {
  const error = useRouteError();
  const message = error instanceof Error ? error.message : String(error);

  return (
    <Panel title="Страница не отрисовалась">
      <p className="break-all text-sm text-[var(--color-sell)]">{message}</p>
      <p className="mt-3 text-xs text-[var(--color-muted)]">
        Соединение с web_api не разорвано — можно вернуться{" "}
        <Link to="/" className="underline">
          к списку рынков
        </Link>
        .
      </p>
    </Panel>
  );
}
